import React from 'react'
import "./loader.css"

const Loader = () => {
  return (
    <div className='loader-outer'>
      <div className='loader-inner'>
        <p className='first loader-p'>l</p>
        <p className='second loader-p'>o</p>
        <p className='third loader-p'>a</p>
        <p className='fourth loader-p'>d</p>
        <p className='fifth loader-p'>i</p>
        <p className='sixth loader-p'>n</p>
        <p className='seventh loader-p'>g</p>
      </div>
    </div>
  )
}
export default Loader